import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

/**
 * Drop-in wrapper: renders a <div class="relative"> around an <input>
 * with an eye toggle on the right. Accepts the same props as <input>.
 * Works for both native <input> and shadcn-styled inputs.
 */
export default function PasswordInput({ className = '', style = {}, InputComponent = 'input', ...props }) {
  const [visible, setVisible] = useState(false);

  const Comp = InputComponent;

  return (
    <div className="relative">
      <Comp
        {...props}
        type={visible ? 'text' : 'password'}
        className={`${className} pr-10`}
        style={style}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setVisible(v => !v)}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-0.5 rounded-md opacity-50 hover:opacity-100 transition-opacity"
        style={{ color: style?.color || 'var(--theme-textSecondary, currentColor)' }}
        data-testid={props['data-testid'] ? `${props['data-testid']}-toggle-visibility` : 'toggle-password-visibility'}
        aria-label={visible ? 'Hide password' : 'Show password'}
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
